import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

const SelectBox = ({ data, val, text, onChange, label, selected, name }) => (
  <div className="form-group">
    <label className="control-label">{label}</label>
    <select
      className="form-control"
      name={name}
      value={selected}
      onChange={onChange}
    >
      <option value="" selected>
        --Please Select--
      </option>
      {_.map(data, (item) => (
        <option key={`${name}_${item[val]}`} value={item[val]}>
          {item[text]}
        </option>
      ))}
    </select>
  </div>
);

SelectBox.propTypes = {
  data: PropTypes.array.isRequired,
  val: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  selected: PropTypes.string,
  name: PropTypes.string,
};

export default SelectBox;
